import moment from 'moment';
import {
  GET_LISTING_DATA_STEP3_START,
  GET_LISTING_DATA_STEP3_SUCCESS,
  GET_LISTING_DATA_STEP3_ERROR
} from '../constants';
import { initialize, change } from 'redux-form';
import { userListingStep3 as query } from '../lib/graphql';

export function getListingDataStep3(listId) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: GET_LISTING_DATA_STEP3_START,
    });

    try {
      let formValues = null, settingFieldsData = {}, listData = {}, calendars = {}, updatedAvailableDatesPrices = [];
      let houseRules = [], updatedBlockedDates = [], updatedDisabledDates = [], updatedAvailableDates = [], firstHalfBlocked = [];
      let secondHalfBlocked = [], firstHalfAvailable = [], secondHalfAvailable = [], firstHalfDisabled = [], secondHalfDisabled = [], fullBlockedDates = [];
      let firstHalfBooked = [], secondHalfBooked = [];

      // Send Request to get listing data
      const { data } = await client.query({
        query,
        variables: { listId: Number(listId), preview: true },
        fetchPolicy: 'network-only',
      });

      if (data?.UserListing) {
        // Preparing List data
        listData = data?.UserListing?.listingData;
        calendars = data?.UserListing?.calendars;

        // Preparing for house rules
        if (data?.UserListing?.houseRules?.length > 0) {
          data?.UserListing?.houseRules?.map((item, value) => {
            houseRules.push(parseInt(item?.houseRulesId));
          });
          settingFieldsData = Object.assign({}, listData, { houseRules });
        }

        // Preparing for blocked dates
        if (data?.UserListing?.blockedDates?.length > 0) {

          const todayDate = moment.utc(new Date()).format('YYYY-MM-DD');
          data?.UserListing?.blockedDates?.map((item, value) => {
            const itemDate = moment.utc(item?.blockedDates).format('YYYY-MM-DD');
            // Parse as local time at noon to avoid UTC-midnight shifting the
            // calendar day for timezones behind UTC (e.g. America/La_Paz).
            // moment.utc(...).toDate() yields the previous evening locally,
            // which made DayPicker highlight day-1 (14/15 -> 13/14).
            const newItemDate = moment(item?.blockedDates, moment.ISO_8601).hours(12).minutes(0).seconds(0).milliseconds(0).toDate();

            if (itemDate >= todayDate) {
              if (item?.reservationId) {
                if (item?.dayStatus === 'full') {
                  updatedDisabledDates.push(newItemDate);
                }
                if (item?.dayStatus === 'firstHalf') {
                  firstHalfDisabled.push(newItemDate);
                  firstHalfBooked.push(moment(newItemDate).format('YYYY-MM-DD'));
                } else if (item?.dayStatus === 'secondHalf') {
                  secondHalfDisabled.push(newItemDate);
                  secondHalfBooked.push(moment(newItemDate).format('YYYY-MM-DD'));
                } else if (item?.reservationId && (item?.dayStatus !== 'firstHalf' || item?.dayStatus !== 'secondHalf')) {
                  fullBlockedDates.push(newItemDate);
                }
              }
              if (item?.calendarStatus === 'available') {
                updatedAvailableDates.push(newItemDate);
                updatedAvailableDatesPrices.push({
                  date: newItemDate,
                  isSpecialPrice: item?.isSpecialPrice,
                });
                if (item?.dayStatus === 'firstHalf') {
                  firstHalfAvailable.push(newItemDate);
                } else if (item?.dayStatus === 'secondHalf') {
                  secondHalfAvailable.push(newItemDate);
                }
              }
              if (item?.calendarStatus && item?.calendarStatus === 'blocked' && !item.reservationId) {
                updatedBlockedDates.push(newItemDate);
                if (item?.dayStatus === 'firstHalf') {
                  firstHalfBlocked.push(newItemDate);
                } else if (item?.dayStatus === 'secondHalf') {
                  secondHalfBlocked.push(newItemDate);
                }
              }
            }
          });

          const intersectionFirstHalfBlocked = firstHalfDisabled.filter(element => secondHalfBooked.includes(moment(element).format('YYYY-MM-DD')));
          const intersectionSecondHalfBlocked = secondHalfDisabled.filter(element => firstHalfBooked.includes(moment(element).format('YYYY-MM-DD')));
          updatedDisabledDates = [...updatedDisabledDates, ...intersectionFirstHalfBlocked, ...intersectionSecondHalfBlocked];

          updatedAvailableDatesPrices = updatedAvailableDatesPrices.reduce(
            (data, o) => {
              if (
                !data.some(
                  (obj) =>
                    moment(obj.date).format('YYYY-MM-DD') ===
                    moment(o.date).format('YYYY-MM-DD')
                )
              ) {
                data.push(o);
              }
              return data;
            },
            []
          );
          settingFieldsData = {
            ...listData,
            ...settingFieldsData,
            disabledDates: updatedDisabledDates,
            blockedDates: updatedBlockedDates,
            availableDates: updatedAvailableDates,
            availableDatesPrices: updatedAvailableDatesPrices,
            halfDates: {
              firstHalfAvailable,
              secondHalfAvailable,
              firstHalfBlocked,
              secondHalfBlocked,
              firstHalfDisabled,
              secondHalfDisabled,
            },
            fullBlockedDates,
          };
        }

        await dispatch(change('ListPlaceStep3', 'calendars', calendars));
        if (updatedBlockedDates) {
          await dispatch(change('ListPlaceStep3', 'blockedDates', updatedBlockedDates));
        } else if (updatedAvailableDates) {
          await dispatch(change('ListPlaceStep3', 'blockedDates', updatedAvailableDates));
        } else if (updatedAvailableDatesPrices) {
          await dispatch(change('ListPlaceStep3', 'blockedDates', updatedAvailableDatesPrices));
        }

        formValues = Object.assign({}, data.UserListing, settingFieldsData, listData, calendars);

        // Reinitialize the form values
        await dispatch(initialize('ListPlaceStep3', formValues));

        // Dispatch a success action
        dispatch({
          type: GET_LISTING_DATA_STEP3_SUCCESS,
          step3DataIsLoaded: true,
          isExistingList: true,
          calendars: data.UserListing.calendars
        });
      } else {
        dispatch({
          type: GET_LISTING_DATA_STEP3_ERROR,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_LISTING_DATA_STEP3_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }
    return true;
  };
}

